import AccountDeletionForm from '@components/forms/AccountDeletionForm.vue'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'DeleteAccountModal',
  components: {
    'account-deletion-form-component': AccountDeletionForm,
  },
  props: {
    deleteAccountModalVisible: {
      required: true,
      type: Boolean,
    },
  },
  computed: {
    deleteAccountBtnLoading() {
      return this.$store.state.users.delete.deleteAccountLoading
    },
    ...mapState({
      deleteAccountBtnLoading: (state) => state.users.delete.deleteAccountLoading,
      deleteAccountError: (state) => state.users.delete.deleteAccountError,
      deleteAccountErrorMessage: (state) => state.users.delete.deleteAccountErrorMessage,
    }),
  },
  methods: {
    ...mapActions('users/delete', ['deleteAccount', 'clearState']),
    initiateDeleteAccount() {
      // Before deleting, validate the form
      this.$refs.accountDeletionForm.validateForm()
    },
    triggerDeleteAccount(password) {
      this.deleteAccount(password).then(() => {
        if (!this.deleteAccountError) {
          // Navigate to the logout route
          this.$router.push({ path: '/' })
        }
      })
    },
    beforeClose(done) {
      this.closeModal()
      done()
    },
    closeModal() {
      this.clearState()
      this.$emit('close-modal')
    },
  },
}
